// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setCanScrollNextHandler from "@store/Framework/Store/Bunzl/Pages/ProductDetails/Handlers/SetCanScrollNext";
import setCanScrollPrevHandler from "@store/Framework/Store/Bunzl/Pages/ProductDetails/Handlers/SetCanScrollPrev";
import { useDispatch, useSelector } from "react-redux";

export default () => {
    const dispatch = useDispatch();
    const { canScrollNext, canScrollPrev } = useSelector((state: ApplicationState) => state.bunzl.pages.productDetails);

    const setCanScrollNext = (value: boolean | undefined) => {
        if (typeof value !== "undefined") {
            dispatch(setCanScrollNextHandler(value));
        }
    };

    const setCanScrollPrev = (value: boolean | undefined) => {
        if (typeof value !== "undefined") {
            dispatch(setCanScrollPrevHandler(value));
        }
    };

    return {
        canScrollNext,
        canScrollPrev,
        setCanScrollNext,
        setCanScrollPrev,
    };
};
